// extracted by mini-css-extract-plugin
export default {"dragDropHeader":"DragTitle_dragDropHeader__PJK3h","cursorPointer":"DragTitle_cursorPointer__Jnm5r"};